import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    // background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;

      &:after {
        top: 15px;
        left: 15px;
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      // mix-blend-mode: screen;
      // filter: grayscale(100%) contrast(1);
      transition: var(--transition);
      filter: sepia(100%);
      // mix-blend-mode: color;
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      // background-color: var(--navy);
      mix-blend-mode: screen;
      // filter: sepia(50%);
      // mix-blend-mode: color;
    }

    &:after {
      border: 2px solid var(--green);
      top: 20px;
      left: 20px;
      z-index: -1;
    }
  }

  .tooltip {
    position: relative;
    // display: inline-block;
    // display: block;
  }

  /* Tooltip text */
  .tooltip .tooltiptext {
    visibility: hidden;
    text-align: center;
    top: 102.5%;
    padding: 5px 5px;
    position: absolute;
    bottom: 100%;
    // z-index: 1;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = [
    'Java Spring Boot',
    'Microservices',
    'REST APIs',
    'MySQL',
    'Python',
    'Git',
    'ReactJS',
    'CSS',
    'Bootstrap',
    'HTML',
  ];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
              Hi! I am Rafsha and I am always up for a good challenge. My interest lies in
              everything creative, be it developing interactive and attractive UI pages, developing
              a solution to a complex problem or powering a computer to automate human tasks.
            </p>

            <p>
              I graduated with a Bachelors degree in Computer Science from one of{' '}
              <a href="https://www.pasha.org.pk/pashapk/University-Rankings_P@SHA-Salary-Survey-Report-2021.pdf">
                Pakistan's leading Computer Science universities
              </a>
              , <a href="http://isb.nu.edu.pk/">FAST NUCES</a> in July 2021. Ever since I have been
              developing microservices using JAVA and Spring Boot, at client companies, outsourced
              as a consultant from <a href="https://www.systemsltd.com/">a software house</a>.
            </p>

            <p>
              I take pride in being an ambitious and quick learner. I strive to be adept at
              everything I do and to constantly refine myself in my knowledge and my practice, as a
              software engineer.
            </p>

            <p>Some of the technologies that I have been exploring lately include:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            
              <StaticImage
                className="img"
                src="../../images/me2.PNG"
                width={500}
                quality={95}
                formats={['AUTO', 'WEBP', 'AVIF']}
                alt="Headshot"
              />
            
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
